import React, { useState, useEffect } from 'react';
import axios from 'axios';
import '../../App.css'; 
import ResearchSidebar from '../../Components/ResearchSidebar';
import { API_BASE_URL } from '../../utils/apiConfig.js';

const CATEGORIES = ["Bakery", "Dairy & Eggs", "Produce", "Frozen", "Meat & Seafood", "Deli", "Baking Essentials",
                    "Snacks & Candy", "Beverages", "Breakfast", "Canned Goods & Soups", "Condiments & Sauces", 
                    "Dry Goods & Pasta", "Oils, Vinegars, & Spices", "Prepared Foods", "Beer", "Hard Beverages", 
                    "Liquor", "Wine"];

const ManagePopups = () => {
    const [popupType, setPopupType] = useState('');
    const [appearanceType, setAppearanceType] = useState('');
    const [responses, setResponses] = useState([]);
    const [secondaryResponses, setSecondaryResponses] = useState([]);
    const [links, setLinks] = useState([]);

    const [activeTab, setActiveTab] = useState('add');
    const [popups, setPopups] = useState([]);
    const [message, setMessage] = useState('');

    const [popupData, setPopupData] = useState({
        popupName: '', popupType: '', appearanceType: '', appearanceTime: '', description: '', 
        popupMessage: '', responses: [], page: '',  image: '', linkPage: [], secondaryMessage: '', 
        secondaryResponses: [], isDismissible: true
    });

    // clear message on tab change
    useEffect(() => {
        setMessage('');
    }, [activeTab]);

    // handlers
    const handlePopupChange = (e) => {
        setPopupData({ ...popupData, [e.target.name]: e.target.value });
    };
    
    const handleSelectPopupType = (e) => {
        const type = e.target.value;
        setPopupType(type);
        setPopupData({ ...popupData, popupType: type });
    };

    const handleSelectAppearanceType = (e) => {
        const type = e.target.value;
        setAppearanceType(type);
        setPopupData({ ...popupData, appearanceType: type });
    };

    const handleSelectAppearanceTime = (e) => {
        const time = e.target.value;
        setPopupData({ ...popupData, appearanceTime: time });
    };

    const handleResponseChange = (index, value) => {
        const newResponses = [...responses];
        newResponses[index] = value;

        setResponses(newResponses);
        setPopupData(prev => ({
            ...prev,
            responses: newResponses,
        }));
    };

    const handleLinkChange = (index, value) => {
        const newLinks = [...links];
        newLinks[index] = value;

        setLinks(newLinks);
        setPopupData(prev => ({
            ...prev,
            linkPage: newLinks,
        }));
    };

    const parseField = (field) => {
        if (Array.isArray(field)) return field;
        try { return JSON.parse(field) ?? []; } 
        catch { return []; }
    };

    const addResponseField = () => {
        const newResponses = [...responses, ''];
        const newLinks = [...links, ''];
        setResponses(newResponses);
        setLinks(newLinks);
        setPopupData(prev => ({
            ...prev,
            responses: newResponses,
            linkPage: newLinks,
        }));
    };

    const removeResponseField = (index) => {
        const newResponses = responses.filter((_, i) => i !== index);
        const newLinks = links.filter((_, i) => i !== index);
        setResponses(newResponses);
        setLinks(newLinks);
        setPopupData(prev => ({
            ...prev,
            responses: newResponses,
            linkPage: newLinks,
        }));
    };

    /* secondary response changes */
    const handleSecondaryResponseChange = (index, value) => {
        const newResponses = [...secondaryResponses];
        newResponses[index] = value;

        setSecondaryResponses(newResponses);
        setPopupData(prev => ({
            ...prev,
            secondaryResponses: newResponses,
        }));
    };

    const addSecondaryResponseField = () => {
        const newResponses = [...secondaryResponses, ''];
        setSecondaryResponses(newResponses);
        setPopupData(prev => ({
            ...prev,
            secondaryResponses: newResponses,
        }));
    };

    const removeSecondaryResponseField = (index) => {
        const newResponses = secondaryResponses.filter((_, i) => i !== index);
        setSecondaryResponses(newResponses);
        setPopupData(prev => ({
            ...prev,
            secondaryResponses: newResponses,
        }));
    };

    /* Handle Submit Popups */
    const handleSubmitPopup = async (e) => {
        e.preventDefault();
        try {
            await axios.post(`${API_BASE_URL}/api/add-popups`, {
                popup: popupData,
            });
            setMessage('Popup Added Successfully!');
            setTimeout(() => {
                setMessage('');
            }, 20000);
            await loadPopups();
        } catch (error) {
            console.error(error);
            setMessage('Error adding popup.');
        }
    };

    const loadPopups = async () => {
        try {
            const response = await axios.post(
                `${API_BASE_URL}/api/get-popups`
            );

            const payload = response.data?.result ?? response.data ?? [];

            setPopups(Array.isArray(payload) ? payload : []);
        } catch (err) {
            console.error(err);
            setMessage('Error getting popups.');
        }
    };

    useEffect(() => {
        loadPopups();
    }, []);

    const handleDelete = async (id) => {
        if(!window.confirm("Are you sure? This will also delete all unsaved participant responses.")) return;
        try {
            await axios.delete(`${API_BASE_URL}/api/popups/${id}`);
            await loadPopups();
            setMessage('Popup Deleted.');
            setTimeout(() => {
                setMessage('');
            }, 10000);
        } catch (err) {
            console.error(err);
            setMessage('Error deleting popup.');
        }
    };

    return (
        <main className="dashboard-layout">
            <ResearchSidebar />

            <div className="dashboard-content">
                <h1 className="page-title">Manage Popups</h1>
                
                <div className="tab-container">
                <button 
                    type="button"
                    className={`tab-btn ${activeTab === 'add' ? 'active' : ''}`}
                    onClick={() => setActiveTab('add')}
                >
                    Add New Popup
                </button>
                <button 
                    type="button"
                    className={`tab-btn ${activeTab === 'remove' ? 'active' : ''}`}
                    onClick={() => setActiveTab('remove')}
                >
                    Remove Popup
                </button>
            </div>
            
            {message && (
                <div style={{ padding: '10px', background: '#d4edda', color: '#155724', borderRadius: '8px', marginBottom: '20px' }}>
                    {message}
                </div>
            )}

            {/* add popup form*/}
            {activeTab === 'add' && (
                <div className="modern-card">
                    <form onSubmit={handleSubmitPopup}>
                        <h3 style={{ marginTop: 0, borderBottom: '1px solid #eee', paddingBottom: '10px' }}>Basic Information</h3>
                        
                        <div className="grid-2-col">
                            <div className="form-group">
                                <label className="form-label">Popup Name *</label>
                                <input className="modern-input" name="popupName" maxLength={254} onChange={handlePopupChange} required />
                            </div>
                            <div className="form-group" name="popupType">
                                <label className="form-label">Popup Type *</label>
                                <select name="popupType" className="modern-input" onChange={handleSelectPopupType} required>
                                    <option value="">Select Popup Type</option>
                                    <option value="Message">Message</option>
                                    <option value="Multiple-Choice">Multiple-Choice</option>
                                </select>                      
                            </div>

                            <div className="form-group">
                                <label className="form-label">Appearance Type *</label>
                                <select name="appearanceType" className="modern-input" onChange={handleSelectAppearanceType} required>
                                    <option value="">Select Appearance Type</option>
                                    <option value="On Specific Page">On Specific Page</option>
                                    <option value="On Category Page">On Category Page</option>
                                </select>                   
                            </div>

                            <div className="form-group">
                                <label className="form-label">Appearance Time in Seconds (Enter only the integer value) *</label>
                                <input className="modern-input" maxLength={100} onChange={handleSelectAppearanceTime} required />
                            </div>
                        </div>

                        {/* text areas */}
                        <div className="form-group">
                            <label className="form-label">Description (Enter "-" if none) *</label>
                            <textarea className="modern-input" maxLength={500} name="description" rows="3" onChange={handlePopupChange} required />
                        </div>

                        {/* popup information */}
                        <h3 style={{ marginTop: '20px', borderBottom: '1px solid #eee', paddingBottom: '10px' }}>
                            Popup Information
                        </h3>

                        <div>
                            <div>
                                <div className="form-group">
                                    <label className="form-label">Popup Message *</label>
                                    <textarea className="modern-input" name="popupMessage" maxLength={254} rows="3" onChange={handlePopupChange} required />
                                </div>
                            </div>

                            {appearanceType === 'On Category Page' && (
                                <div className="form-group">
                                    <label className="form-label">Select Page for Popup to Appear *</label>
                                    <select name="page" className="modern-input" onChange={handlePopupChange} required>
                                        <option value="">Select Appearance Page</option>
                                        {CATEGORIES.map((cat) => (
                                            <option value={`/products/category/${encodeURI(cat)}`}>{cat}</option>
                                        ))}
                                    </select>                     
                                </div>
                            )}
                            
                            {appearanceType === 'On Specific Page' && (
                                <div className="form-group">
                                    <label className="form-label">Select Page for Popup to Appear *</label>
                                    <select name="page" className="modern-input" onChange={handlePopupChange} required>
                                        <option value="">Select Appearance Page</option>
                                        <option value="/">Home</option>
                                        <option value="/products">Products</option>
                                        <option value="/cart">Cart</option>
                                        <option value="/search">Search Results</option>
                                    </select>                      
                                </div>
                            )}

                            <div className="form-group">
                                <label className="form-label">Dismissibility *</label>
                                <select name="isDismissible" className="modern-input" onChange={handlePopupChange} required>
                                    <option value={true}>Select Dismissibility</option>
                                    <option value={true}>Dismissible</option>
                                    <option value={false}>Not Dismissible</option>
                                </select>                      
                            </div>

                            {popupType === 'Multiple-Choice' && (
                                <div>
                                    <div className="form-group">
                                        <label className="form-label">
                                            Multiple-Choice Responses
                                        </label>
                                        {responses.map((response, index) => (
                                            <div key={index} style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
                                                <input
                                                    className="modern-input"
                                                    placeholder={`Response ${index + 1}`}
                                                    value={response}
                                                    onChange={(e) => handleResponseChange(index, e.target.value)}
                                                />
                                                <select name="linkPage" className="modern-input" onChange={(e) => handleLinkChange(index, e.target.value)}>
                                                    <option value="">Select Page To Link To (Optional)</option>
                                                    <option value="/">Home</option>
                                                    <option value="/products">Products</option>
                                                    <option value="/cart">Cart</option>
                                                    <option value="/search">Search Results</option>
                                                    {CATEGORIES.map((cat) => (
                                                        <option value={`/products/category/${encodeURI(cat)}`}>{cat}</option>
                                                    ))}
                                                </select>  
                                                <button type="button" onClick={() => removeResponseField(index)} className="btn-danger">Remove</button>
                                            </div>
                                        ))}
                                        <button type="button" onClick={addResponseField} className="add-response-btn">Add Response</button>
                                    </div>

                                    <div className="form-group">
                                        <label className="form-label">Secondary Message (Optional)</label>
                                        <textarea className="modern-input" name="secondaryMessage" maxLength={254} rows="3" onChange={handlePopupChange} />
                                    </div>
                                    
                                    <div className="form-group">
                                        <label className="form-label">
                                            Secondary Responses
                                        </label>
                                        {secondaryResponses.map((response, index) => (
                                            <div key={index} style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
                                                <input
                                                    className="modern-input"
                                                    placeholder={`Response ${index + 1}`}
                                                    value={response}
                                                    onChange={(e) => handleSecondaryResponseChange(index, e.target.value)}
                                                /> 
                                                <button type="button" onClick={() => removeSecondaryResponseField(index)} className="btn-danger">Remove</button>
                                            </div>
                                        ))}
                                        <button type="button" onClick={addSecondaryResponseField} className="add-response-btn">Add Response</button>
                                    </div>
                                </div>
                            )}

                            {(popupType === 'Message') && 
                                <div className="form-group">
                                    <label className="form-label">Select Page for Popup to Link To</label>
                                    <select name="linkPage" className="modern-input" onChange={handlePopupChange}>
                                        <option value="">Select Link</option>
                                        <option value="/">Home</option>
                                        <option value="/products">Products</option>
                                        <option value="/cart">Cart</option>
                                        <option value="/search">Search Results</option>
                                        {CATEGORIES.map((cat) => (
                                            <option value={`/products/category/${encodeURI(cat)}`}>{cat}</option>
                                        ))}
                                    </select>                     
                                </div>
                            }

                            <div className="form-group">
                                <label className="form-label">Popup Image URL (Image Address from Browser)</label>
                                <input className="modern-input" name="image" maxLength={255} onChange={handlePopupChange} />
                            </div>
                        </div>

                        <div style={{ marginTop: '2rem', textAlign: 'right' }}>
                            <button type="submit" className="btn-primary">Save Popup</button>
                        </div>
                    </form>
                </div>
            )}

            {/* remove popup form */}
            {activeTab === 'remove' && (
                <div className="modern-card">
                    <form>
                        <div className="form-group" style={{ gap: '10px' }}>
                            <h3>Current Popups</h3>
                            {popups.length > 0 ? (
                                popups.map((popup, index) => (
                                    <div key={popup.popupId ?? index} className="popup-list">

                                    <div className="popup-list-header">
                                        {popup.image && (
                                            <img
                                                src={popup.image}
                                                alt=""
                                                onError={(e) => {
                                                if (e.target.src !== window.location.origin + "/imageComingSoon.jpg") {
                                                    e.target.src = "/imageComingSoon.jpg";
                                                }
                                                }}
                                            />
                                        )}
                                        <div className="popup-list-header-text">
                                            <p className="popup-list-name">{popup.popupName}</p>
                                            <span className="popup-list-type-badge">{popup.popupType}</span>
                                        </div>
                                    </div>

                                    <div className="popup-list-body">
                                        <div className="popup-list-field">
                                            <p className="popup-list-label">Appearance Type</p>
                                            <p className="popup-list-value">{popup.appearanceType}</p>
                                        </div>
                                        <div className="popup-list-field">
                                            <p className="popup-list-label">Appearance Time</p>
                                            <p className="popup-list-value">{popup.appearanceTime ? `${popup.appearanceTime}s` : '—'}</p>
                                        </div>
                                        <div className="popup-list-field">
                                            <p className="popup-list-label">Appearance Page</p>
                                            <p className="popup-list-value">{popup.page === '/' ? `Home` : `${popup.page}`}</p>
                                        </div>
                                        <div className="popup-list-field">
                                            <p className="popup-list-label">Link To</p>
                                            {parseField(popup.linkPage).map((page, i) => (
                                                <p key={i} className="popup-list-value">{page}</p>
                                            ))}
                                        </div>
                                        <div className="popup-list-field">
                                            <p className="popup-list-label">Message</p>
                                            <p className="popup-list-value">{popup.popupMessage}</p>
                                        </div>
                                        <div className="popup-list-field">
                                            <p className="popup-list-label">Secondary Message</p>
                                            <p className="popup-list-value">{popup.secondaryMessage}</p>
                                        </div>
                                        <div className="popup-list-field">
                                            <p className="popup-list-label">Responses</p>
                                            {parseField(popup.responses).map((r, i) => (
                                                <p key={i} className="popup-list-value">{r}</p>
                                            ))}                                      
                                        </div>
                                        <div className="popup-list-field">
                                            <p className="popup-list-label">Secondary Responses</p>
                                            {parseField(popup.secondaryResponses).map((r, i) => (
                                                <p key={i} className="popup-list-value">{r}</p>
                                            ))}   
                                        </div>
                                        <div className="popup-list-field" style={{ gridColumn: '1 / -1' }}>
                                            <p className="popup-list-label">Description</p>
                                            <p className="popup-list-value">{popup.description}</p>
                                        </div>
                                        <div className="popup-list-field">
                                            <p className="popup-list-label">Dismissibility</p>
                                            <p className="popup-list-value">{popup.isDismissible ? "Dismissible" : "Not Dismissible"}</p>
                                        </div>
                                    </div>

                                    <div className="popup-list-footer">
                                        <button
                                            type="button"
                                            onClick={() => handleDelete(popup.popupId)}
                                            className="btn-danger"
                                        >
                                            Remove
                                        </button>
                                    </div>

                                    </div>
                                ))
                            ) : (
                            <p>No popups found.</p>
                            )}
                        </div>
                    </form>
                </div>
            )}
        </div>
    </main>
);
};

export default ManagePopups;